// Scope chosen when a breaking change is requested on a recurring tactic. Explicit string
// values (not the bare word `this`) keep the discriminator readable and self-documenting.
// `cancel`/dismiss is intentionally NOT part of this enum — it's a separate UI action.
export enum RecurrenceBreakScope {
  ThisInstance = 'this-instance',
  ThisAndFollowing = 'this-and-following',
  AllInstances = 'all-instances',
}
